import type { Customer } from "server/dwhApi/customers/types.js";

export enum Metric {
  RECYCLING_RATE = "recyclingRate",
  GENERAL_WASTE = "generalWaste",
  CONTAMINATION = "contamination",
}

export type LeaderboardTab = { key: Metric; label: string };

export enum Direction {
  TOP = "top",
  BOTTOM = "bottom",
}

export type BaseTenant = {
  id: string;
  name: string;
  category: string;
  rate: number;
  general: number;
  contamination: number;
  idx: number;
  isDeleted: boolean;
};

export type RankedTenant = BaseTenant & { mv: number; position: number };

export enum NumericTenantKey {
  RATE = "rate",
  GENERAL = "general",
  CONTAMINATION = "contamination",
}

export type MetricConfig = {
  key: NumericTenantKey;
  higherBetter: boolean;
  format: (t: BaseTenant) => string;
};

export type LeaderboardRow = {
  tenant: RankedTenant;
  rank: number;
  top: boolean;
};

export type CustomerWithPosition = Customer & {
  position: number;
};

export type GroupedCustomers = {
  metricValue: number;
  customers: Customer[];
};
